export async function copyText(text: string): Promise<void> {
  const clipboard = (navigator as unknown as { readonly clipboard?: Clipboard }).clipboard;
  if (clipboard === undefined) {
    throw new Error('Clipboard access is not available in this environment.');
  }
  await clipboard.writeText(text);
}

export function downloadText(
  text: string,
  filename: string,
  mimeType = 'text/plain;charset=utf-8',
): void {
  if (
    typeof document === 'undefined' ||
    typeof URL === 'undefined' ||
    typeof URL.createObjectURL !== 'function'
  ) {
    throw new Error('Downloads are not available in this environment.');
  }

  const blobUrl = URL.createObjectURL(new Blob([text], { type: mimeType }));
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = sanitizeDownloadName(filename);
  link.hidden = true;
  document.body.append(link);
  link.click();
  link.remove();
  setTimeout(() => {
    URL.revokeObjectURL(blobUrl);
  }, 0);
}

export function sanitizeDownloadName(filename: string): string {
  const base = filename.replaceAll('\\', '/').split('/').filter(Boolean).at(-1) ?? 'download.txt';
  const sanitized = replaceControlCharacters(base.replace(/[<>:"/\\|?*]/gu, '-'), '-').trim();
  return sanitized.length === 0 ? 'download.txt' : sanitized;
}

function replaceControlCharacters(value: string, replacement: string): string {
  let result = '';
  for (let index = 0; index < value.length; index += 1) {
    const code = value.charCodeAt(index);
    result += code < 32 || code === 127 ? replacement : value.charAt(index);
  }
  return result;
}
